// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"abe90f73","282":"86e89f13","359":"a13c43b6","453":"6bd49f49","751":"e221262c"}[chunkId] + ".chunk.js";
};